import React from 'react';

const AdminNewsBanner = () => (
  <div className="admin-news-banner" role="status">
    <span className="admin-news-banner__label">Новость</span>
    <p className="admin-news-banner__text">
      МойСклад повышает минимальную стоимость приложений лояльности.
      С&nbsp;1&nbsp;июля 2026&nbsp;года подписка на решение составит{' '}
      <strong>1&nbsp;400&nbsp;₽ в месяц</strong>.
      При оплате за год вы получите скидку — годовая подписка выгоднее помесячной.
    </p>
  </div>
);

export default AdminNewsBanner;
